import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';
import formatarData from '~js/formatar-data';

Vue.use(VueResource);

function prepararParaSalvarWebFornecedor(webFornecedor) {
  return webFornecedor;
}


function prepararParaExibirWebFornecedor(webFornecedor) {
  // Caso em que NAO existem respostas
  if (webFornecedor.webFormRespostasFornecedor.length === 0) {
    for (let i = 1; i <= 9; i = i + 1) {
      webFornecedor.webFormRespostasFornecedor.push({
        idFormPergunta: i,
        idWebFornecedor: '',
        resposta: null,
        dataCriacao: null,
      });
    }
  } else { // Caso em que existem respostas
    for (let formResposta of webFornecedor.webFormRespostasFornecedor) {
      switch (formResposta.resposta) {
        case 0: formResposta.resposta = '0'; break;
        case 1: formResposta.resposta = '1'; break;
        case 2: formResposta.resposta = '2'; break;
        default: formResposta.resposta = null;
      }
    }
  }

  if (webFornecedor.webCertidoes.length > 0) {
    for (let certidao of webFornecedor.webCertidoes) {
      if (!certidao.nomeArquivo || certidao.nomeArquivo === "undefined") {
        certidao.nomeArquivo = "Sem arquivo";
      }
    }
  }
  
  return webFornecedor;
}


async function prepararParaSalvar(pessoa) {

  if (pessoa.dataNascimento) {
    pessoa.dataNascimento = await formatarData.paraNumero(pessoa.dataNascimento);
  }

  return pessoa;
}


export default {
  busca: documento => {
    return Vue.http.get('/api/webpessoas/busca', {
      params: {
        documento
      }
    })
    .then(resposta => resposta.body);
  },
  fornecedor: () => {
    return Vue.http.get('/api/webpessoas/fornecedor')
      .then(resposta => prepararParaExibirWebFornecedor(resposta.body));
  },
  cadastrarFornecedor: async (fornecedor, arquivos, arquivosCertidao) => {

    //fornecedor = await prepararParaSalvar(fornecedor);
    fornecedor = prepararParaSalvarWebFornecedor(fornecedor);
    fornecedor.arquivos = arquivos;
    fornecedor.arquivosCertidao = arquivosCertidao;

    fornecedor = converterObjetoFormData(fornecedor);

    return Vue.http.post('/api/webpessoas/fornecedor', fornecedor)
      .then(resposta => resposta.body);
  },
  alterarFornecedor: async (fornecedor, arquivos, arquivosCertidao) => {
    fornecedor = prepararParaSalvarWebFornecedor(fornecedor);

    //fornecedor = await prepararParaSalvar(fornecedor);
    fornecedor.arquivos = arquivos;
    fornecedor.arquivosCertidao = arquivosCertidao;
    fornecedor = converterObjetoFormData(fornecedor);

    return Vue.http.put('/api/webpessoas/fornecedor', fornecedor)
      .then(resposta => resposta.body);
  },
  dadosBancarios: documento => {
    return Vue.http.get('/api/webpessoas/dadosbancarios', {
      params: {
        documento
      }
    })
    .then(resposta => resposta.body);
  },
  arquivos: id => {
      return Vue.http.get(`/api/webpessoas/${id}/arquivos`)
          .then(response => response.data);
  },

  arquivosCertidao: (idCertidao) => {
    return Vue.http.get(`/api/webpessoas/${idCertidao}/arquivoCertidao`)
      .then(response => response.data);
  },

  download: (id, arquivo) => {
      return Vue.http.get(`/api/webpessoas/${id}/downloadarquivo/${arquivo}`, {
          responseType: 'blob'
      })
          .then(response => {
              return salvarArquivo(response, arquivo);
          });
  },

  downloadCertidao: (idCertidaoPessoa, arquivoCertidao) => {
    return Vue.http.get(`/api/webpessoas/${idCertidaoPessoa}/downloadarquivocertidao/${arquivoCertidao}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivoCertidao);
      });
  },

  pessoa: () => {
    return Vue.http.get('/api/webpessoas/pessoafisica')
      .then(resposta => resposta.body);
  },
  cadastrarPessoa: async (pessoa, arquivos) => {
    pessoa = await prepararParaSalvar(pessoa);
    pessoa.arquivos = arquivos;
    pessoa = converterObjetoFormData(pessoa);

    return Vue.http.post('/api/webpessoas/pessoafisica', pessoa)
      .then(resposta => resposta.body);
  },
  alterarPessoa: async (pessoa, arquivos) => {
    pessoa = await prepararParaSalvar(pessoa);
    pessoa.arquivos = arquivos;
 
    pessoa = converterObjetoFormData(pessoa);

    return Vue.http.put('/api/webpessoas/pessoafisica', pessoa)
      .then(resposta => resposta.body);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/web-pessoa/servico.js